import React, { Component } from 'react';
import { Glyphicon, Modal } from 'react-bootstrap';
import './LocationForm.css';
import DatePicker from 'react-date-picker';
import {
  CreateLocation,
  GenerateAprivaDeviceAddress,
  GetAvailableFridgeSchemas,
  GetPriceMapTemplates,
  GetPlanogramNames,
} from '../libs/GraphQL';
import { StateOptionsList } from '../components/StateList';
import sortAlphabetically from '../utils/sortAlphabetically';
import DisplayRowSearch from '../components/DisplayRow/Search';
const today = new Date();
export default class LocationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertModal: {
        mode: false,
        text: '',
      },
      layoutNames: [],
      fridgeSchemaTemplates: [],
      priceMapTemplates: [],
      request: {
        accessTo: 'Private',
        aprivaDeviceAddress: '',
        id: '',
        street: '',
        city: '',
        state: 'IL',
        zipCode: '',
        baseCommission: '',
        directions: '',
        fridgeSchema: 'MW_STANDARD/latest',
        hours: '1',
        holidayScreenEnabled: '0',
        holidayScreenFridgeSpecific: '0',
        holidayScreenStartDate: '',
        holidayScreenEndDate: '',
        latitude: '',
        longitude: '',
        layoutName: '',
        onlineDate: today,
        percentage: '0',
        prettyName: '',
        prod: '0',
        publicStatus: 'OFFLINE',
        priceMapTemplate: 'PMT_STANDARD',
        reserve: '0',
        route: '',
        status: 'OFFLINE',
        stockingSchedule: {
          Mon: 1,
          Tue: 1,
          Wed: 1,
          Thu: 1,
          Fri: 1,
          Sat: 0,
          Sun: 0,
        },
        stop: '0',
        taxRate: '2.25',
        vertical: 'Office',
        workHours: {},
        timeZone: 'CHICAGO',
      },
      dailyHours: {
        fromMon: '',
        toMon: '',
        fromTue: '',
        toTue: '',
        fromWed: '',
        toWed: '',
        fromThu: '',
        toThu: '',
        fromFri: '',
        toFri: '',
        fromSat: '',
        toSat: '',
        fromSun: '',
        toSun: '',
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleHoursChange = this.handleHoursChange.bind(this);
    this.handleStateChange = this.handleStateChange.bind(this);
    this.handleCopyFromHours = this.handleCopyFromHours.bind(this);
    this.handleCopyToHours = this.handleCopyToHours.bind(this);
  }

  async UNSAFE_componentWillMount() {
    this.uniqueLayoutNames();
    this.uniquePMTNames();
    this.uniqueFridgeSchemaNames();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  async uniqueLayoutNames() {
    try {
      const response = await GetPlanogramNames();

      this.setState({ layoutNames: response });
    } catch (e) {
      const alertModal = this.state.alertModal;
      alertModal.mode = true;
      // var errorString = JSON.stringify(e);
      // var errorObject = JSON.parse(errorString);
      alertModal.text =
        'Unable to load Layout names, Please check your internet and your permissions';
      this.setState({ alertModal });
    }
  }

  async uniqueFridgeSchemaNames() {
    try {
      const schemaResponse = await GetAvailableFridgeSchemas();
      //update schemaResponse to include schemaId
      const parsedSchemaResponse = schemaResponse?.map((e) => {
        return e.schemaId;
      });
      this.setState({
        fridgeSchemaTemplates: parsedSchemaResponse,
      });
    } catch (e) {
      const alertModal = this.state.alertModal;
      alertModal.mode = true;
      alertModal.text =
        'Unable to load Fridge Schema templates, Please check your internet and your permissions';
      this.setState({ alertModal });
    }
  }

  async uniquePMTNames() {
    try {
      const response = await GetPriceMapTemplates();
      this.setState({ priceMapTemplates: response });
    } catch (e) {
      const alertModal = this.state.alertModal;
      alertModal.mode = true;
      // var errorString = JSON.stringify(e);
      // var errorObject = JSON.parse(errorString);
      alertModal.text =
        'Unable to load Price map templates, Please check your internet and your permissions';
      this.setState({ alertModal });
    }
  }

  handleChange(event) {
    const requestObject = this.state.request;
    requestObject[event.target.name] = event.target.value;
    this.setState({ request: requestObject });
  }

  handleHoursChange(event) {
    const dailyHours = this.state.dailyHours;
    dailyHours[event.target.name] = event.target.value;
    this.setState({ dailyHours });
  }

  handleStateChange(event) {
    const requestObject = this.state.request;
    requestObject[event.target.name] = event.target.value;

    if (event.target.value === 'IL') {
      requestObject.taxRate = 2.25;
    }
    if (event.target.value === 'WI') {
      requestObject.taxRate = 0;
    }
    if (event.target.value === 'IN') {
      requestObject.taxRate = 2.25;
    }
    if (event.target.value === 'NY') {
      requestObject.taxRate = 2.25;
    }
    if (event.target.value === 'NJ') {
      requestObject.taxRate = 2.25;
    }
    if (event.target.value === 'PA') {
      requestObject.taxRate = 2.25;
    }

    this.setState({ request: requestObject });
  }

  handleCopyFromHours(event) {
    const dailyHours = this.state.dailyHours;
    dailyHours.fromTue = dailyHours.fromMon;
    dailyHours.fromWed = dailyHours.fromMon;
    dailyHours.fromThu = dailyHours.fromMon;
    dailyHours.fromFri = dailyHours.fromMon;
    this.setState({ dailyHours });
  }

  handleCopyToHours(event) {
    const dailyHours = this.state.dailyHours;
    dailyHours.toTue = dailyHours.toMon;
    dailyHours.toWed = dailyHours.toMon;
    dailyHours.toThu = dailyHours.toMon;
    dailyHours.toFri = dailyHours.toMon;
    this.setState({ dailyHours });
  }

  getRequiredValidation(field) {
    if (this.state.request[field].length === 0) {
      return false;
    }
    return true;
  }

  getHoursRequiredValidation(field) {
    if (this.state[field] === 1) {
      return true;
    }
    if (
      this.state.dailyHours.fromMon !== '' &&
      this.state.dailyHours.fromTue !== '' &&
      this.state.dailyHours.fromWed !== '' &&
      this.state.dailyHours.fromThu !== '' &&
      this.state.dailyHours.fromFri !== '' &&
      this.state.dailyHours.fromSat !== '' &&
      this.state.dailyHours.fromSun !== '' &&
      this.state.dailyHours.toMon !== '' &&
      this.state.dailyHours.toTue !== '' &&
      this.state.dailyHours.toWed !== '' &&
      this.state.dailyHours.toThu !== '' &&
      this.state.dailyHours.toFri !== '' &&
      this.state.dailyHours.toSat !== '' &&
      this.state.dailyHours.toSun !== ''
    ) {
      return true;
    }
    return false;
  }

  validateContent(field) {
    let re = '';
    switch (field) {
      case 'baseCommission':
        re = /^\d+(\.\d{1,3})?$/;
        return re.test(this.state.request[field]);
      case 'id':
        re = /^[a-zA-Z0-9_]*$/;
        return re.test(this.state.request[field]);
      case 'zipCode':
        re = /^[0-9]{5}(?:-[0-9]{4})?$/;
        return re.test(this.state.request[field]);
      case 'latitude':
        // eslint-disable-next-line no-restricted-globals
        if (!isNaN(this.state.request[field])) {
          if (
            this.state.request[field] < 28 ||
            this.state.request[field] > 49
          ) {
            return false;
          }
          if (this.state.request[field].toString().includes('.')) {
            const length = this.state.request[field]
              .toString()
              .split('.')[1].length;
            return length > 0 && length < 8;
          }
          return true;
        }
        return false;

      case 'longitude':
        // eslint-disable-next-line no-restricted-globals
        if (!isNaN(this.state.request[field])) {
          if (
            this.state.request[field] > -67 ||
            this.state.request[field] < -128
          ) {
            return false;
          }
          if (this.state.request[field].toString().includes('.')) {
            const length = this.state.request[field]
              .toString()
              .split('.')[1].length;
            return length > 0 && length < 8;
          }
          return true;
        }
        return false;

      case 'percentage':
        re = /^(?:100(?:\.00?)?|\d?\d(?:\.\d\d?)?)$/;
        return re.test(this.state.request[field]);
      case 'stop':
        re = /^[0-9]+$/;
        return re.test(this.state.request[field]);
      case 'taxRate':
        re = /^([0-2])?[0-9](\.[0-9]([0-9])?)?$/;
        return re.test(this.state.request[field]);
      default:
        return false;
    }
  }

  formRequest() {
    // modify onlineDate and hours according to the input to string.
    const requestString = JSON.stringify(this.state.request);
    const requestObject = JSON.parse(requestString); // this converts everything to string equivalent, including onlineDate
    if (requestObject.hours === '1') {
      requestObject.hours = '24 Hours';
      const workHours = {
        Mon: [['00:00', '23:59']],
        Tue: [['00:00', '23:59']],
        Wed: [['00:00', '23:59']],
        Thu: [['00:00', '23:59']],
        Fri: [['00:00', '23:59']],
        Sat: [['00:00', '23:59']],
        Sun: [['00:00', '23:59']],
      };
      requestObject.workHours = workHours;
    } else {
      const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
      const dailyHours = this.state.dailyHours;
      let prevFrom = 'fromMon';
      let prevTo = 'toMon';
      let hours = '';
      const outputDays = ['0'];
      let i = 0;
      let from;
      let to;
      for (i = 0; i < days.length; i++) {
        from = `from${days[i]}`;
        to = `to${days[i]}`;
        if (
          dailyHours[from].trim().length === 0 ||
          dailyHours[to].trim().length === 0
        ) {
          dailyHours[from] = '';
          dailyHours[to] = '';
        }
      }
      for (i = 1; i < days.length; i++) {
        from = `from${days[i]}`;
        to = `to${days[i]}`;
        if (
          dailyHours[from] === dailyHours[prevFrom] &&
          dailyHours[to] === dailyHours[prevTo]
        ) {
          let temp = outputDays.pop();
          temp = `${temp},${i}`;
          outputDays.push(temp);
        } else {
          outputDays.push(i.toString());
        }
        prevFrom = from;
        prevTo = to;
      }
      outputDays.forEach(function (str) {
        const start = parseInt(str.charAt(0), 10);
        const end = parseInt(str.charAt(str.length - 1), 10);
        let tempHours = '';
        if (days[start] === days[end]) {
          tempHours = `${tempHours + days[start]} `;
        } else {
          tempHours = `${tempHours + days[start]}-${days[end]} `;
        }

        if (
          dailyHours[`from${days[start]}`].trim().length === 0 ||
          dailyHours[`to${days[start]}`].trim().length === 0
        ) {
          return;
        }
        tempHours = `${tempHours + dailyHours[`from${days[start]}`]} to ${
          dailyHours[`to${days[start]}`]
        }; `;

        hours += tempHours;
      });
      const workHours = {};
      if (
        this.state.dailyHours.fromMon !== '' &&
        this.state.dailyHours.toMon !== ''
      ) {
        workHours.Mon = [
          [this.state.dailyHours.fromMon, this.state.dailyHours.toMon],
        ];
      }
      if (
        this.state.dailyHours.fromTue !== '' &&
        this.state.dailyHours.toTue !== ''
      ) {
        workHours.Tue = [
          [this.state.dailyHours.fromTue, this.state.dailyHours.toTue],
        ];
      }
      if (
        this.state.dailyHours.fromWed !== '' &&
        this.state.dailyHours.toWed !== ''
      ) {
        workHours.Wed = [
          [this.state.dailyHours.fromWed, this.state.dailyHours.toWed],
        ];
      }
      if (
        this.state.dailyHours.fromThu !== '' &&
        this.state.dailyHours.toThu !== ''
      ) {
        workHours.Thu = [
          [this.state.dailyHours.fromThu, this.state.dailyHours.toThu],
        ];
      }
      if (
        this.state.dailyHours.fromFri !== '' &&
        this.state.dailyHours.toFri !== ''
      ) {
        workHours.Fri = [
          [this.state.dailyHours.fromFri, this.state.dailyHours.toFri],
        ];
      }
      if (
        this.state.dailyHours.fromSat !== '' &&
        this.state.dailyHours.toSat !== ''
      ) {
        workHours.Sat = [
          [this.state.dailyHours.fromSat, this.state.dailyHours.toSat],
        ];
      }
      if (
        this.state.dailyHours.fromSun !== '' &&
        this.state.dailyHours.toSun !== ''
      ) {
        workHours.Sun = [
          [this.state.dailyHours.fromSun, this.state.dailyHours.toSun],
        ];
      }
      requestObject.hours = hours;
      requestObject.workHours = workHours;
    }
    requestObject.onlineDate = requestObject.onlineDate.substring(0, 10);
    requestObject.holidayScreenStartDate =
      requestObject.holidayScreenStartDate.substring(0, 10);
    requestObject.holidayScreenEndDate =
      requestObject.holidayScreenEndDate.substring(0, 10);
    if (requestObject.timeZone === 'NEWYORK') {
      // Normal default is M/T/W/Th/F. NE Default should be Sun/Tue/Thu.
      requestObject.stockingSchedule.Sun = 1;
      requestObject.stockingSchedule.Mon = 0;
      requestObject.stockingSchedule.Wed = 0;
      requestObject.stockingSchedule.Fri = 0;
    }
    return requestObject;
  }

  async handleSubmit(event) {
    event.preventDefault();
    const requestObject = this.formRequest();
    let apiResponse;
    try {
      apiResponse = await CreateLocation(requestObject);
      if ('id' in apiResponse && apiResponse.id === this.state.request.id) {
        this.props.history.push(`/locations/detail/${this.state.request.id}`);
      }
    } catch (e) {
      console.error(e);
      const alertModal = this.state.alertModal;
      alertModal.mode = true;
      const errorString = JSON.stringify(e);
      const errorObject = JSON.parse(errorString);
      if ('response' in errorObject) {
        alertModal.text = errorObject.response.data.message;
      } else {
        alertModal.text =
          'Unable to Submit new location, Check your internet and your permissions';
      }
      this.setState({ alertModal });
    }
  }

  render() {
    return (
      <form name="locationForm" onSubmit={this.handleSubmit}>
        <div id="alertBox">
          <Modal show={this.state.alertModal.mode}>
            <Modal.Body>
              <div className="form-group">{this.state.alertModal.text}</div>
            </Modal.Body>
            <Modal.Footer>
              &nbsp;
              <button
                type="button"
                className="btn btn-warning"
                onClick={() => {
                  const alertModal = this.state.alertModal;
                  alertModal.mode = false;
                  this.setState({ alertModal });
                }}
              >
                Close
              </button>
            </Modal.Footer>
          </Modal>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalAccessTo"
            className="col-sm-2 control-label"
          >
            Access To<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <select
              name="accessTo"
              defaultValue="Private"
              onChange={this.handleChange}
              className="form-control"
            >
              <option value="Private">Private</option>
              <option value="Public">Public</option>
            </select>
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('accessTo') && <Glyphicon glyph="ok" />}
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="formHorizontalid" className="col-sm-2 control-label">
            Id<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              name="id"
              id="formHorizontalid"
              onChange={this.handleChange}
              placeholder="Unique ID of the location"
              title="No empty values and special characters allowed, Alphanumeric only"
              pattern="^[a-zA-Z0-9_]*$"
              className="form-control"
              required
            />
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('id') && this.validateContent('id') && (
              <Glyphicon glyph="ok" />
            )}
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="formStreet" className="col-sm-2 control-label">
            Street<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              name="street"
              id="formStreet"
              onChange={this.handleChange}
              placeholder="Enter street"
              title="No empty values allowed"
              className="form-control"
              required
            />
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('street') && <Glyphicon glyph="ok" />}
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="formCity" className="col-sm-2 control-label">
            City<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              name="city"
              id="formCity"
              onChange={this.handleChange}
              placeholder="Enter City"
              title="No empty values allowed"
              className="form-control"
              required
            />
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('city') && <Glyphicon glyph="ok" />}
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="formState" className="col-sm-2 control-label">
            State<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <select
              defaultValue="IL"
              name="state"
              onChange={this.handleStateChange}
              className="form-control"
            >
              <StateOptionsList />
            </select>
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('state') && <Glyphicon glyph="ok" />}
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="formZipCode" className="col-sm-2 control-label">
            Zip Code<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              name="zipCode"
              id="formZipCode"
              onChange={this.handleChange}
              placeholder="Enter Zip Code"
              title="No empty values. Format: nnnnn or nnnnn-nnnn"
              className="form-control"
              required
              pattern="^[0-9]{5}(?:-[0-9]{4})?$"
            />
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('zipCode') &&
              this.validateContent('zipCode') && <Glyphicon glyph="ok" />}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalBaseCommission"
            className="col-sm-2 control-label"
          >
            Base Commisssion
          </label>
          <div className="col-sm-9">
            <input
              type="number"
              name="baseCommission"
              id="formHorizontalBaseCommission"
              onChange={this.handleChange}
              placeholder="Enter base commission"
              step="0.001"
              className="form-control"
              min="0"
              title="Decimal values allowed upto three decimal places"
            />
          </div>
          <div className="col-sm-1">
            {this.validateContent('baseCommission') && <Glyphicon glyph="ok" />}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalDirections"
            className="col-sm-2 control-label"
          >
            Directions<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              name="directions"
              id="formHorizontalDirections"
              onChange={this.handleChange}
              placeholder="Enter directions"
              title="No empty values allowed"
              className="form-control"
              required
            />
          </div>
          <div className="form-group">
            <label
              htmlFor="formHorizontalFridgeSchemaTemplate"
              className="col-sm-2 control-label"
            >
              Fridge Schema<font className="mandatory">*</font>
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                name="fridgeSchema"
                id="formHorizontalFridgeSchema"
                value={this.state.request.fridgeSchema}
                onChange={this.handleChange}
                placeholder="Enter Fridge Schema"
                className="form-control"
                list="fridgeSchema-options"
                required
              />
              <datalist id="fridgeSchema-options">
                {/* Ensure MW_STANDARD/latest is first value bc is default on intiialization */}
                <option value="MW_STANDARD/latest" />
                {sortAlphabetically(
                  Object.values(this.state.fridgeSchemaTemplates),
                ).map((fridgeSchemaValue) => (
                  <option
                    key={fridgeSchemaValue}
                    value={`${fridgeSchemaValue}/latest`}
                  />
                ))}
              </datalist>
            </div>
            <div className="col-sm-1">
              {this.getRequiredValidation('fridgeSchema') && (
                <Glyphicon glyph="ok" />
              )}
            </div>
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('directions') && (
              <Glyphicon glyph="ok" />
            )}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalHours"
            className="col-sm-2 control-label"
          >
            24 Hours ?<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <select
              defaultValue="1"
              name="hours"
              onChange={this.handleChange}
              className="form-control"
            >
              <option value="0">No</option>
              <option value="1">Yes</option>
            </select>

            {this.state.request.hours === '0' && (
              <div id="weekHours" className="form-group col-sm-8">
                <font className="mandatory" size="2">
                  *Leave empty to denote holiday on a specific day
                </font>
                <table id="weekHoursTable">
                  <tbody>
                    <tr>
                      <th> </th>
                      <th>Mon</th>
                      <th>Tuesday</th>
                      <th>Wednesday</th>
                      <th>Thursday</th>
                      <th>Friday</th>
                      <th>Saturday</th>
                      <th>Sunday</th>
                      <th> </th>
                    </tr>
                    <tr>
                      <td>From</td>
                      <td>
                        <input
                          name="fromMon"
                          type="time"
                          onChange={this.handleHoursChange}
                          value={this.state.dailyHours.fromMon}
                        />
                      </td>
                      <td>
                        <input
                          name="fromTue"
                          type="time"
                          onChange={this.handleHoursChange}
                          value={this.state.dailyHours.fromTue}
                        />
                      </td>
                      <td>
                        <input
                          name="fromWed"
                          type="time"
                          onChange={this.handleHoursChange}
                          value={this.state.dailyHours.fromWed}
                        />
                      </td>
                      <td>
                        <input
                          name="fromThu"
                          type="time"
                          onChange={this.handleHoursChange}
                          value={this.state.dailyHours.fromThu}
                        />
                      </td>
                      <td>
                        <input
                          name="fromFri"
                          type="time"
                          onChange={this.handleHoursChange}
                          value={this.state.dailyHours.fromFri}
                        />
                      </td>
                      <td>
                        <input
                          name="fromSat"
                          type="time"
                          onChange={this.handleHoursChange}
                          value={this.state.dailyHours.fromSat}
                        />
                      </td>
                      <td>
                        <input
                          name="fromSun"
                          type="time"
                          onChange={this.handleHoursChange}
                          value={this.state.dailyHours.fromSun}
                        />
                      </td>
                      <td>
                        <input
                          type="button"
                          value="Copy till friday"
                          onClick={this.handleCopyFromHours}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>To</td>
                      <td>
                        <input
                          name="toMon"
                          type="time"
                          min={this.state.dailyHours.fromMon}
                          onChange={this.handleHoursChange}
                          value={this.state.dailyHours.toMon}
                        />
                      </td>
                      <td>
                        <input
                          name="toTue"
                          type="time"
                          min={this.state.dailyHours.fromTue}
                          onChange={this.handleHoursChange}
                          value={this.state.dailyHours.toTue}
                        />
                      </td>
                      <td>
                        <input
                          name="toWed"
                          type="time"
                          min={this.state.dailyHours.fromWed}
                          onChange={this.handleHoursChange}
                          value={this.state.dailyHours.toWed}
                        />
                      </td>
                      <td>
                        <input
                          name="toThu"
                          type="time"
                          min={this.state.dailyHours.fromThu}
                          onChange={this.handleHoursChange}
                          value={this.state.dailyHours.toThu}
                        />
                      </td>
                      <td>
                        <input
                          name="toFri"
                          type="time"
                          min={this.state.dailyHours.fromFri}
                          onChange={this.handleHoursChange}
                          value={this.state.dailyHours.toFri}
                        />
                      </td>
                      <td>
                        <input
                          name="toSat"
                          type="time"
                          min={this.state.dailyHours.fromSat}
                          onChange={this.handleHoursChange}
                          value={this.state.dailyHours.toSat}
                        />
                      </td>
                      <td>
                        <input
                          name="toSun"
                          type="time"
                          min={this.state.dailyHours.fromSun}
                          onChange={this.handleHoursChange}
                          value={this.state.dailyHours.toSun}
                        />
                      </td>
                      <td>
                        <input
                          type="button"
                          value="Copy till friday"
                          onClick={this.handleCopyToHours}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('hours') && <Glyphicon glyph="ok" />}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalHolidayScreenEnabled"
            className="col-sm-2 control-label"
          >
            Holiday Screen Enabled
          </label>
          <div className="col-sm-9">
            <select
              name="holidayScreenEnabled"
              onChange={this.handleChange}
              className="form-control"
              defaultValue="0"
            >
              <option value="0">No</option>
              <option value="1">Yes</option>
            </select>
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('holidayScreenEnabled') && (
              <Glyphicon glyph="ok" />
            )}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalHolidayScreenFridgeSpecific"
            className="col-sm-2 control-label"
          >
            Holiday Screen Fridge specific
          </label>
          <div className="col-sm-9">
            <select
              name="holidayScreenFridgeSpecific"
              onChange={this.handleChange}
              className="form-control"
              defaultValue="0"
            >
              <option value="0">No</option>
              <option value="1">Yes</option>
            </select>
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('holidayScreenFridgeSpecific') && (
              <Glyphicon glyph="ok" />
            )}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalHolidayScreenStartDate"
            className="col-sm-2 control-label"
          >
            Holiday Start
          </label>
          <div className="col-sm-9">
            <DatePicker
              className="form-date"
              onChange={(value) => {
                const requestObject = this.state.request;
                requestObject.holidayScreenStartDate = value;
                this.setState({ request: requestObject });
              }}
              value={this.state.request.holidayScreenStartDate}
            />
          </div>
          <div className="col-sm-1" />
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalHolidayScreenEndDate"
            className="col-sm-2 control-label"
          >
            Holiday End
          </label>
          <div className="col-sm-9">
            <DatePicker
              className="form-date"
              onChange={(value) => {
                const requestObject = this.state.request;
                requestObject.holidayScreenEndDate = value;
                this.setState({ request: requestObject });
              }}
              value={this.state.request.holidayScreenEndDate}
            />
          </div>
          <div className="col-sm-1" />
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalLatitude"
            className="col-sm-2 control-label"
          >
            Latitude<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <input
              type="number"
              name="latitude"
              id="formHorizontalLatitude"
              onChange={this.handleChange}
              placeholder="Enter Latitude"
              className="form-control"
              title="decimal values allowed between 28 and 49 upto 7 decimal places. No empty value"
              min="28"
              max="49"
              step="0.0000001"
              required
            />
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('latitude') &&
              this.validateContent('latitude') && <Glyphicon glyph="ok" />}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalLongitude"
            className="col-sm-2 control-label"
          >
            Longitude<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <input
              type="number"
              name="longitude"
              id="formHorizontalLongitude"
              onChange={this.handleChange}
              placeholder="Enter Longitude"
              title="decimal values allowed, with upto 7 decimal places between -128 and -67. No empty value"
              className="form-control"
              min="-128"
              max="-67"
              step="0.0000001"
              required
            />
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('longitude') &&
              this.validateContent('longitude') && <Glyphicon glyph="ok" />}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalLayoutName"
            className="col-sm-2 control-label"
          >
            Layout Name<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              name="layoutName"
              id="formHorizontalLayoutName"
              onChange={this.handleChange}
              placeholder="Enter Layout Name"
              className="form-control"
              list="layoutName-options"
              required
            />
            <datalist id="layoutName-options">
              {this.state.layoutNames.map((option) => (
                <option key={option} value={option} />
              ))}
            </datalist>
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('layoutName') && (
              <Glyphicon glyph="ok" />
            )}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalOnlineDate"
            className="col-sm-2 control-label"
          >
            OnlineDate<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <DatePicker
              className="form-date"
              onChange={(value) => {
                const requestObject = this.state.request;
                requestObject.onlineDate = value;
                this.setState({ request: requestObject });
              }}
              value={this.state.request.onlineDate}
              required
            />
          </div>
          <div className="col-sm-1" />
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalPercentage"
            className="col-sm-2 control-label"
          >
            Percentage
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              name="percentage"
              id="formHorizontalPercentage"
              onChange={this.handleChange}
              placeholder="Enter Percentage"
              className="form-control"
              title="0 to 100 with 2 decimal places allowed"
              pattern="^(?:100(?:\.00?)?|\d?\d(?:\.\d\d?)?)$"
              value={this.state.request.percentage}
            />
          </div>
          <div className="col-sm-1">
            {this.validateContent('percentage') && <Glyphicon glyph="ok" />}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalPrettyName"
            className="col-sm-2 control-label"
          >
            Pretty Name<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              name="prettyName"
              id="formHorizontalPrettyName"
              onChange={this.handleChange}
              placeholder="Enter pretty name"
              className="form-control"
              required
            />
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('prettyName') && (
              <Glyphicon glyph="ok" />
            )}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalPriceMapTemplate"
            className="col-sm-2 control-label"
          >
            Price map template<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              name="priceMapTemplate"
              id="formHorizontalPriceMapTemplate"
              value={this.state.request.priceMapTemplate}
              onChange={this.handleChange}
              placeholder="Enter Price Map Template"
              className="form-control"
              list="priceMapTemplate-options"
              required
            />
            <datalist id="priceMapTemplate-options">
              {!this.state.priceMapTemplates.includes('PMT_STANDARD') && (
                <option value="PMT_STANDARD" />
              )}
              {sortAlphabetically(
                Object.values(this.state.priceMapTemplates),
              ).map((priceMapValue) => (
                <option key={priceMapValue} value={priceMapValue} />
              ))}
            </datalist>
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('priceMapTemplate') && (
              <Glyphicon glyph="ok" />
            )}
          </div>
        </div>

        <div className="form-group">
          <label
            htmlFor="formHorizontalProd"
            className="col-sm-2 control-label"
          >
            Ready for allocation<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <select
              name="prod"
              onChange={this.handleChange}
              className="form-control"
              defaultValue="0"
            >
              <option value="0">No</option>
              <option value="1">Yes</option>
            </select>
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('prod') && <Glyphicon glyph="ok" />}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalPublicStatus"
            className="col-sm-2 control-label"
          >
            Public Status<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <select
              name="publicStatus"
              defaultValue="OFFLINE"
              onChange={this.handleChange}
              className="form-control"
            >
              <option value="LIVE">LIVE</option>
              <option value="OFFLINE">OFFLINE</option>
            </select>
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('publicStatus') && (
              <Glyphicon glyph="ok" />
            )}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalReserve"
            className="col-sm-2 control-label"
          >
            Reserve and Pay<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <select
              name="reserve"
              defaultValue="0"
              onChange={this.handleChange}
              className="form-control"
            >
              <option value="0">No</option>
              <option value="1">Yes</option>
            </select>
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('reserve') && <Glyphicon glyph="ok" />}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalRoute"
            className="col-sm-2 control-label"
          >
            Route
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              name="route"
              id="formHorizontalRoute"
              onChange={this.handleChange}
              placeholder="Enter Route"
              className="form-control"
            />
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('route') && <Glyphicon glyph="ok" />}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalStatus"
            className="col-sm-2 control-label"
          >
            Status<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <select
              name="status"
              defaultValue="OFFLINE"
              onChange={this.handleChange}
              className="form-control"
            >
              <option value="LIVE">LIVE</option>
              <option value="OFFLINE">OFFLINE</option>
            </select>
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('status') && <Glyphicon glyph="ok" />}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalStop"
            className="col-sm-2 control-label"
          >
            Stop
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              value={this.state.request.stop}
              name="stop"
              id="formHorizontalStop"
              onChange={this.handleChange}
              placeholder="Enter stop"
              pattern="^[0-9]+$"
              title="Format: Any positive number"
              className="form-control"
            />
          </div>
          <div className="col-sm-1">
            {this.validateContent('stop') && <Glyphicon glyph="ok" />}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalTaxRate"
            className="col-sm-2 control-label"
          >
            Tax Rate<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              value={this.state.request.taxRate}
              name="taxRate"
              id="formHorizontalTaxRate"
              onChange={this.handleChange}
              placeholder="Enter Tax Rate"
              title="Any value between 0 to 29.999"
              pattern="^([0-2])?[0-9](\.[0-9]([0-9])?([0-9])?)?$"
              className="form-control"
              required
            />
          </div>
          <div className="col-sm-1">
            {this.validateContent('taxRate') && <Glyphicon glyph="ok" />}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontalVertical"
            className="col-sm-2 control-label"
          >
            Vertical<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <select
              name="vertical"
              defaultValue="Office"
              onChange={this.handleChange}
              className="form-control"
            >
              <option value="Airport">Airport</option>
              <option value="B&I">B&I</option>
              <option value="Education">Education</option>
              <option value="Healthcare">Healthcare</option>
              <option value="Marketing">Marketing</option>
              <option value="Office">Office</option>
              <option value="Other">Other</option>
              <option value="Retail">Retail</option>
              <option value="Travel/Leisure">Travel/Leisure</option>
              <option value="Testing">Testing</option>
              <option value="Residential Property">Residential Property</option>
            </select>
          </div>
          <div className="col-sm-1">
            {this.getRequiredValidation('vertical') && <Glyphicon glyph="ok" />}
          </div>
        </div>
        <div className="form-group">
          <label
            htmlFor="formHorizontaltimeZone"
            className="col-sm-2 control-label"
          >
            Timezone<font className="mandatory">*</font>
          </label>
          <div className="col-sm-9">
            <select
              name="timeZone"
              defaultValue="CHICAGO"
              onChange={this.handleChange}
              className="form-control"
            >
              <option value="CHICAGO">Central</option>
              <option value="NEWYORK">Eastern</option>
              <option value="DENVER">Mountain</option>
              <option value="LOSANGELES">Pacific</option>
            </select>
          </div>
        </div>
        <div className="col-sm-12 submitButton">
          <input type="submit" value="Create" className="btn-success" />
        </div>
      </form>
    );
  }
}
